import { CampaignListCardController } from './campaign-list-card.controller'

function campaignListCard () {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      getAllCampaigns: '&'
    },
    templateUrl: '/campaigns/directives/campaign-list-card/campaign-list-card.html?$$REVISION$$',
    controller: CampaignListCardController
  }
}

export { campaignListCard }
